/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer } from "../../shared";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { CalendarHierarchyControl } from "./controls/CalendarHierarchyControl";
import { UnitsControl } from "./controls/UnitsControl";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useDescription } from "./hooks/useDescription";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { SLIDE_NUMBER } from "./constants";

export default function Slide35(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const description = useDescription();

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <CommoditiesControl />
          <UnitsControl />
          <CalendarHierarchyControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid current={exportMode ? "export" : "default"}>
          <ReportRenderer componentId="table" />
          <ReportRenderer componentId="line-chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
